import React from 'react';
import { connect } from 'react-redux';
import { Col, Typography } from 'antd';
import { Field } from 'formik';

import AntSelect from '../commons/AntSelect';
import AntInput from '../commons/AntInput';
import withControlledOpen from './withControlledOpen';
import {
  channels,
  classTags,
  techTags,
  typeTags,
} from '../../store/selectors/collections';

const { Text } = Typography;

const controlledSelect = withControlledOpen(AntSelect);

const style = {
  item: {
    marginBottom: 0,
  },
};
const renderInputField = (title, name) => (
  <Col lg={4} key={title}>
    <Text type="secondary">{title}</Text>
    <Field
      name={name}
      placeholder="start typing..."
      component={AntInput}
      itemStyle={style.item}
    />
  </Col>
);

const renderSelectField = (title, name, options) => {
  return (
    <Col lg={4} key={title}>
      <Text type="secondary" style={{ whiteSpace: 'nowrap' }}>
        {title}
      </Text>
      <Field
        name={name}
        placeholder="click and start typing..."
        component={controlledSelect}
        options={options}
        itemStyle={style.item}
        mode="multiple"
        maxTagTextLength={5}
        maxTagCount={0}
        allowClear
      />
    </Col>
  );
};

const ExtraColumn = ({ field, channels, classTags, techTags, typeTags }) => {
  const extraColumns = {
    audience: {
      render: () => renderInputField('Audience (CRM)', 'audience'),
    },
    channel: {
      render: () => renderSelectField('Channels (CRM)', 'channel', channels),
    },
    techTag: {
      render: () =>
        renderSelectField('Technical Tag (Incident)', 'techTag', techTags),
    },
    classTag: {
      render: () =>
        renderSelectField('Class Tag (Incident)', 'classTag', classTags),
    },
    typeTag: {
      render: () =>
        renderSelectField('Type Tag (Incident)', 'typeTag', typeTags),
    },
  };

  return Object.keys(extraColumns)
    .map(key => key === field && extraColumns[key].render())
    .filter(Boolean);
};
const mapStateToProps = state => {
  return {
    channels: channels(state),
    classTags: classTags(state),
    techTags: techTags(state),
    typeTags: typeTags(state),
  };
};
export default connect(mapStateToProps)(ExtraColumn);
